
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Enjoy the best boat cruises in Goa with stunning views, live music, and delicious food on luxury boats.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Explore the top boat cruises in Goa, featuring beautiful sunsets, scenic river views, and great dining. Perfect for romantic nights or group fun.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Experience a lovely evening with Goa’s best boat cruises, offering tasty meals, music, and beautiful views. Great for special events.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'boat cruises in goa, boat cruise in goa price, best boat cruise in goa, dinner boat cruise in goa, private boat cruise in goa',
        },
      ],
    };
  },


  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Scenic Locations",
      text: "Enjoy breathtaking views of Goa's coastline and rivers with our boat cruises!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether it's a family trip or a romantic outing, there's a boat cruise for every occasion!",
    },
    {
      title: "Expert Crew",
      text: "Our friendly and experienced crew ensures you have a safe and memorable journey.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect boat cruise effortlessly through the Goa App at great rates!",
    },
  ],

     
      title: 'Boat Cruise in Goa - Boat Cruise in Goa Price',
    };
  },



jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/boat-cruises-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/boat-cruises-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/boat-cruises-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Boat Cruises in Goa - Book @ ₹1299 Flat 50% Off",
  "description": "Experience a Boat Cruise in Goa with scenic views, delicious meals, and live entertainment, perfect for a memorable evening.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1299",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/boat-cruises-goa",
        "url": "https://www.goa.app/boat-cruises-goa",
        "name": "Boat Cruises in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Boat Cruises in Goa offer a memorable experience with scenic views, delicious meals, and entertainment. Ideal for relaxation or special occasions, these cruises let you enjoy Goa’s beauty and vibrant atmosphere while sailing along its rivers or coastline.",
        "breadcrumb": {
            "@id": "https://www.goa.app/boat-cruises-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/boat-cruises-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
  "@type": "Question",
  "name": "How do I book a boat cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "You can book a boat cruise through various local operators or online platforms. Be sure to check for reviews and confirm your booking in advance."
  }
},
{
  "@type": "Question",
  "name": "Are boat cruise prices fixed in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Boat cruise prices can vary based on the type of cruise, duration, and season. Always inquire about any additional fees before booking."
  }
},
{
  "@type": "Question",
  "name": "What should I bring on a boat cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "It's advisable to bring sunscreen, a hat, swimwear, and any personal items you may need. Some cruises may offer snacks and drinks."
  }
},
{
  "@type": "Question",
  "name": "Are there any safety measures on boat cruises?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, all boats are required to have safety equipment, including life jackets. Make sure to listen to safety briefings before departure."
  }
},
{
  "@type": "Question",
  "name": "Can I pay for the boat cruise with a credit card?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Many boat operators accept credit cards, but it's wise to carry cash as well, especially for smaller operators."
  }
},
{
  "@type": "Question",
  "name": "Do boat crews in Goa speak English?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Most boat crews in Goa can communicate in basic English, particularly in tourist areas. Having your questions ready can help ensure a smooth experience."
  }
},
{
  "@type": "Question",
  "name": "Are there any safety tips for boat cruises in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Always choose licensed operators, note the cruise details, and share your itinerary with someone. Ensure you follow crew instructions during the cruise."
  }
},
{
  "@type": "Question",
  "name": "Can I hire a private boat for a special occasion?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many operators offer private boat rentals for special occasions. You can customize your experience, including duration and amenities. Contact operators directly for arrangements."
  }
},
{
  "@type": "Question",
  "name": "What types of boat cruises are available in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "In Goa, you can find various types of boat cruises, including sunset cruises, dolphin watching tours, dinner cruises, and adventure sports excursions. Choose one that suits your interests!"
  }
},
{
  "@type": "Question",
  "name": "How long do boat cruises typically last?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Most boat cruises in Goa last between 1 to 3 hours, depending on the type of cruise. Full-day charters are also available for more extensive experiences."
  }
},
{
  "@type": "Question",
  "name": "What is the best time to go on a boat cruise in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The best time for boat cruises in Goa is during the winter months (November to February) when the weather is pleasant. Evening cruises during sunset are particularly popular."
  }
          }

        ]
      }
    ]
  };
},


};


  